// new-header
$(window).resize(function() {
  setupScrollMenu().stop();
});

function setupScrollMenu(){
  var pos = 0;
  var header = $('.header._nofixed');
  $(window).on('scroll', function(){
  if($(this).scrollTop() < pos){//上にスクロールしたとき
  header.removeClass('is_fixed');
  header.removeClass('is_up');
  }else if($(this).scrollTop() > 90){//下にスクロールしたとき
  header.addClass('is_up');
  }
  pos = $(this).scrollTop();
  });
}

// PCメニュー操作
function setupPCMenu() {
  // クリックでサブメニュー表示
  $('.new-header-main-li a').on('click', function() {
    $('.new-header-sub').not($($(this).attr('href'))).hide();
    $($(this).attr('href')).fadeToggle(300);
  });

  // ホバーでサブメニュー表示
  $('.new-header-main-li').hover(function() {
    $(this).find('.new-header-sub').stop().fadeIn();
    $(this).find('.new-header-main-li-a').addClass('js-hover');
  }, function() {
    $(this).find('.new-header-sub').stop().fadeOut();
    $(this).find('.new-header-main-li-a').removeClass('js-hover');
  });
}

function openSPMenu() {
  $('.new-header-spmenu-ul').slideUp();
  $('.new-header-spmenu-openbtn').on('click', function () {
    $('.new-header-overlay').addClass('on');
    $('body').addClass('js-spmenu-fixed');
    $('.new-header-spmenu-close').addClass('close');
    $(this).parents().find('.new-header-spmenu-navwrap').addClass('js-nav-open');
    $('.new-header-spmenu-ul').delay(500).slideDown(1200);
  });
}

function openModel() {
  $('#modelsIcon').on('click', function () {
    $('.new-header-overlay').addClass('on');
    $('.new-header-spmenu-close').addClass('close');
    $('#SPmodels').parents().find('.new-header-spmenu-navwrap').addClass('js-nav-open');
    $('.new-header-spmenu-ul').delay(500).slideDown(1200);
    $('#SPmodels').addClass('js-submenu-isopen');
    $('.new-header-spmenu-sublayer').addClass('js-layer-ison');
    $('.new-header-spmenu-back').addClass('js-back-btn');
  });
}

function closeSPMenu() {
  $('.new-header-spmenu-close').on('click', function () {
    if ($('.new-header-spmenu-submenu').hasClass('js-submenu-isopen')) { //サブレイヤーが開いてたら
      $('.new-header-spmenu-submenu').removeClass('js-submenu-isopen');
      $('.new-header-spmenu-sublayer').removeClass('js-layer-ison');
      $('.new-header-spmenu-back').removeClass('js-back-btn');
    } else if ($('.new-header-spmenu-navwrap').hasClass('js-nav-open')) { //メインレイヤーが開いてたら
      $('.new-header-spmenu-navwrap').removeClass('js-nav-open');
      $('.new-header-spmenu-close').removeClass('close');
      $('.new-header-overlay').removeClass('on');
      $('body').removeClass('js-spmenu-fixed');
    } else {
      $('.new-header-spmenu-close').removeClass('close');
      $('.new-header-overlay').removeClass('on');
      $('body').removeClass('js-spmenu-fixed');
    }
  });
}

function backSPMenu() {
  $('.new-header-spmenu-back').on('click', function () {
    $('.new-header-spmenu-submenu').removeClass('js-submenu-isopen');
    $('.new-header-spmenu-sublayer').removeClass('js-layer-ison');
    $('.new-header-spmenu-back').removeClass('js-back-btn');
  });
}

function openSubMenu() {
  $('.new-header-spmenu-li a').on('click', function () {
    $($(this).attr('href')).addClass('js-submenu-isopen');
    $('.new-header-spmenu-sublayer').addClass('js-layer-ison');
    $('.new-header-spmenu-back').addClass('js-back-btn');
  });
}

$(function () {
  setupScrollMenu()
  setupPCMenu();
  openSPMenu();
  openModel();
  closeSPMenu();
  backSPMenu();
  openSubMenu();
});




// new-footer
$(function(){
	//クリックで動くアコーディオン
	$('.new-footer-accordion-dt').click(function(){
        $(this).next('div').slideToggle();
        $(this).toggleClass('js-active');
        $('.new-footer-accordion-dt').not($(this)).next('div').slideUp();
        $('.new-footer-accordion-dt').not($(this)).removeClass('js-active');
	});
});